import styles from './layout.module.scss'

export const LayoutPlugin = {
  id: 'de/obeta/plugins/layout-plugin',
  title: 'Layout',
  description: 'Two column plugin with text and image',
  Renderer: (props) => <div className={styles.root}>{props.children}</div>,
  version: 1,
}
